import { Fragment } from 'react'
import { MainOwnerList, ApartmentConfirmationList, VuokratiliPanel } from '.'
import CustomExpansionPanelList, {
  CustomExpansionPanelContent
} from '../../../../components/Display/Lists/CustomExpansionPanel'
import i18n from '../../../../translations/i18n'
import { Apartment } from '../../../../types/apartments'
import { User } from '../../../../types/users'

interface ApartmentExpansionPanelProps {
  t: i18n.TFunction
  apartment: Apartment
  user: User | undefined
}

const ApartmentExpansionPanel = ({
  t,
  apartment: { client, confirmation, information },
  user
}: ApartmentExpansionPanelProps) => {
  if (confirmation && information) {
    const mainOwnerPanelData:
      | CustomExpansionPanelContent
      | undefined = user && {
      title: t('apartment.clientInformation'),
      Content: <MainOwnerList mainOwner={client?.mainOwner} user={user} t={t} />
    }
    const contractPanelData: CustomExpansionPanelContent = {
      title: t('apartment.confirmation.header'),
      Content: (
        <ApartmentConfirmationList
          apartmentConfirmation={confirmation}
          apartmentInformation={information}
          t={t}
        />
      )
    }
    const vuokratiliPanelData: CustomExpansionPanelContent = {
      title: t('apartment.vuokratiliPanelTitle'),
      badge: t('apartment.newBadge'),
      Content: <VuokratiliPanel t={t} />
    }
    const ExpansionPanelListData = [
      ...(mainOwnerPanelData ? [mainOwnerPanelData] : []),
      contractPanelData,
      vuokratiliPanelData
    ]
    return (
      <CustomExpansionPanelList
        ExpansionPanelListData={ExpansionPanelListData}
      />
    )
  }
  return <Fragment />
}

export default ApartmentExpansionPanel
